module.exports = __webpack_public_path__ + "img/LogoWomenInvestment_Color.5fc7570d.png";